import React from 'react';
import PropTypes from 'prop-types';
import { DashboardApp } from 'smartsuite-dashboard-app';
import useFavorite from '../../hooks/useFavorite';
import customizations from '../../dashboardCommon/customizations';
import assets from '../../dashboardCommon/assets';
import getApiConstants from '../../dashboardCommon/uriConstants';
import { getHelpPageUrl } from '../../utils/apiUtils';

export default function AppWrapper(props) {
    const favoriteUtilities = useFavorite();
    const { helpPageUrl } = getHelpPageUrl();

    return (
        <DashboardApp
            appInsightsFunctions={props.appInsightsFunctions}
            assets={assets}
            baseName="/Dashboard"
            customizations={customizations}
            favoriteUtilities={favoriteUtilities}
            siteLanguage="en"
            uriConstants={getApiConstants(helpPageUrl)}
        />
    );
}

AppWrapper.propTypes = {
    appInsightsFunctions: PropTypes.instanceOf(Object).isRequired,
};
